import { Controller } from "@hotwired/stimulus";
import { visit } from "@hotwired/turbo";

/**
 * Фильтр списком, у которого значение опции — готовый адрес.
 *
 * Адрес собирает вьюха, а не браузер: фильтр виден в адресной строке
 * и работает без JS для тех, кто открывает опцию в новой вкладке.
 */
export default class extends Controller {
  /** Переход к выбранному варианту. */
  go(event) {
    visit(event.currentTarget.value, { action: "advance" });
  }
}
